import React from 'react';
import { ExternalLink } from 'lucide-react';

import { FCTransferActionsMenu } from 'components/warehouse/components/fcTransfers/FCTransferActionsMenu';
import { FC_TRANSFER_DIRECTION } from 'components/warehouse/components/fcTransfers/FCTransferFilterConfig';
import { Button } from 'shadcn/components/ui/Button';

/**
 * Primary view control plus tab-specific overflow actions (tech spec §6.1).
 *
 * @param {Object} props
 * @param {'OUTBOUND' | 'INBOUND'} props.direction
 * @param {() => void} [props.onViewClick]
 * @param {() => void} [props.onEditTransfer]
 * @param {() => void} [props.onDownloadBol]
 * @param {() => void} [props.onCancelTransfer]
 * @param {() => void} [props.onAccept] — used on Inbound tab only (`Accept` / future `Receive`)
 * @param {boolean} [props.isEditTransferDisabled=false]
 * @param {boolean} [props.viewOnly=false] — Merch all-FC list: view control only, no overflow actions
 */
export function FCTransferActionsCell({
    direction = FC_TRANSFER_DIRECTION.OUTBOUND,
    isEditTransferDisabled = false,
    onAccept = () => {},
    onCancelTransfer = () => {},
    onDownloadBol = () => {},
    onEditTransfer = () => {},
    onViewClick = () => {},
    viewOnly = false,
}) {
    return (
        <div className="flex items-center gap-2">
            <Button type="button" variant="ghost" size="icon" aria-label="View FC transfer" onClick={onViewClick}>
                <ExternalLink className="h-4 w-4" />
            </Button>
            {viewOnly ? null : (
                <FCTransferActionsMenu
                    direction={direction}
                    isEditTransferDisabled={isEditTransferDisabled}
                    onEditTransfer={onEditTransfer}
                    onDownloadBol={onDownloadBol}
                    onCancelTransfer={onCancelTransfer}
                    onAccept={onAccept}
                />
            )}
        </div>
    );
}

FCTransferActionsCell.displayName = 'FCTransferActionsCell';
